import type { CeoAccessLogEntry, CeoAccessLogSource, CeoAccessLogStatus } from './types';

/** Журнал доступа в памяти: ручки под него нет. */
const accessLogs: CeoAccessLogEntry[] = [
  {
    id: 'ceo-log-001',
    date: '27.06.2026',
    time: '15:42',
    status: 'success',
    reason: 'PIN подтверждён',
    role: 'CEO',
    source: 'Dashboard',
    createdAt: '2026-06-27T15:42:00+05:00',
  },
  {
    id: 'ceo-log-002',
    date: '27.06.2026',
    time: '14:18',
    status: 'failed',
    reason: 'Неверный PIN',
    role: 'CEO',
    source: 'Dashboard',
    createdAt: '2026-06-27T14:18:00+05:00',
  },
  {
    id: 'ceo-log-003',
    date: '26.06.2026',
    time: '18:05',
    status: 'locked',
    reason: 'Превышено число попыток',
    role: 'CEO',
    source: 'CEO Analytics',
    createdAt: '2026-06-26T18:05:00+05:00',
  },
];

let logCounter = accessLogs.length;

function formatLogDateTime(iso: string): { date: string; time: string } {
  const parsed = new Date(iso);
  return {
    date: new Intl.DateTimeFormat('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(parsed),
    time: new Intl.DateTimeFormat('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
    }).format(parsed),
  };
}

export function appendCeoAccessLog(
  status: CeoAccessLogStatus,
  reason: string,
  source: CeoAccessLogSource,
): CeoAccessLogEntry {
  const createdAt = new Date().toISOString();
  const { date, time } = formatLogDateTime(createdAt);

  const entry: CeoAccessLogEntry = {
    id: `ceo-log-${String(++logCounter).padStart(3, '0')}`,
    date,
    time,
    status,
    reason,
    role: 'CEO',
    source,
    createdAt,
  };

  accessLogs.unshift(entry);
  return entry;
}

/** Снимок только для чтения — пригодится разделу логов. */
export function getCeoAccessLogs(): readonly CeoAccessLogEntry[] {
  return accessLogs;
}
